export default class SalesReportController {
  constructor(ContentService, $uibModal, moment, $filter, isMobile, ProfilePermissionsService, $state) {
    this.service = ContentService;
    this.modal = $uibModal;
    this.moment = moment;
    this.filters = $filter;
    this.isMobile = isMobile;
    this.permissionsService = ProfilePermissionsService;
    this.state = $state;
  }

  $onInit() {
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.groupBy = '0';
    this.rows = [];
    this.csvHeaderOrder = [];
    this.csvHeaders = [];
    this.dateFrom = undefined;
    this.dateTo = undefined;
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  findSalesReport(groupBy=undefined, cashierId=undefined, posId=undefined, famId=undefined, tableId=undefined) {
    this.subscriptions.push(
      this.service.findSalesReport({
        date_from: this.dateFrom.format(),
        date_to: this.dateTo.format(),
        group_by: groupBy || this.groupBy,
        cashier_id: cashierId,
        pos_id: posId,
        fam_id: famId,
        table_id: tableId
      }).subscribe(
        (resultSet) => {
          this.rows = resultSet;
          if (this.isGroupedByDate()) {
            this.buildChartSalesReportByDate(resultSet);
          } else if (this.isGroupedByCashier()) {
            this.buildChartSalesReportByCashier(resultSet);
          } else if (this.isGroupedByTable()) {
            this.buildChartSalesReportByTable(resultSet);
          } else if (this.isGroupedByPOS()) {
            this.buildChartSalesReportByPOS(resultSet);
          } else if (this.isGroupedByCategory()) {
            this.buildChartSalesReportByCategory(resultSet);
          }
          this.reorderCsv();
        },
        (err) => console.log(err)
      )
    );
  }

  openBillDetails(invoiceId) {
    var that = this;
    var hasOrdersPermission = that.permissionsService.hasPermission('invoice-orders');
    var hasBillsPermission = that.permissionsService.hasPermission('account-bills');
    if (hasBillsPermission || hasOrdersPermission){
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'invoice-details-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance, AccountInformationService) => {
          "ngInject";

          $scope.invoice = {};
          $scope.orders = [];
          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
          $scope.showOrders = () => {
            if (hasOrdersPermission){
              $scope.getOrders();
              $scope.ordersShown = true;
            }
          };
          $scope.showInvoice = () => {
            if (hasBillsPermission){
              $scope.ordersShown = false;
            }
          };

          that.subscriptions.push(
            AccountInformationService.getAccountInfo().subscribe(
              (resp) => {
                $scope.account = resp
              }
            )
          );

          if (hasBillsPermission){
            that.subscriptions.push(
              that.service.getInvoice(invoiceId).subscribe(
                (invoice) => $scope.invoice = invoice,
                (error) => console.log("Error while getting the invoice")
              )
            );
          }
          $scope.getOrders = () => {
            if ($scope.orders.length <= 0) {
              that.subscriptions.push(
                that.service.getOrders(invoiceId).subscribe(
                  (orders) => $scope.orders = orders,
                  (error) => console.log("Error while getting the orders")
                )
              );
            }
          };
          if (!hasBillsPermission){
            $scope.showOrders();
          }
          $scope.fetchDetails = (order) => {
            if (!order.details || order.details.length <= 0) {
              that.subscriptions.push(
                that.service.getOrderDetails(invoiceId, order.id).subscribe(
                  (details) => {
                    order.details = details;
                    $scope.displayingOrder = order;
                  },
                  (error) => console.log("Error while getting the details for this order")
                )
              );
            } else {
              $scope.displayingOrder = order;
            }
          };

          $scope.printToCart = (printSectionId) => {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            const styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();            
            const styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
            popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><style>${styleprint.innerHTML}</style><style>${styleprintBootstrap.innerHTML}</style></head><body onload="window.print()">${innerContents}</html>`);
            popupWinindow.document.close();
          };

          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });
    }
  }

  goToItemDrilldown(famId, famName){
    this.state.go('salesByCategory', {
      famId: famId,
      dateTo: this.dateTo,
      dateFrom: this.dateFrom,
      title: famName
    });
  }

  getExportRows() {
    return this.rows.map(row => {
      var newRow = angular.copy(row, {});
      if (newRow.date) {
        newRow.date = this.moment(newRow.date).format('DD/MM/YYYY');
      }
      return newRow;
    });
  }

  getDiscount(item) { return item.discount; }
  getPax(item) { return item.pax; }
  getTotal(item) { return item.total; }
  getExtraTip(item) { return item.extra_tip; }
  getTaxExemption(item) { return item.taxexemption; }
  getTax10(item) { return item.tax10; }
  getTax16(item) { return item.tax16; }

  isGroupedByDate() { return !this.rows.length || this.rows[0].hasOwnProperty('date') && !this.rows[0].hasOwnProperty('rnc'); }
  isGroupedByCashier() { return this.rows.length && this.rows[0].hasOwnProperty('cashier'); }
  isGroupedByTable() { return this.rows.length && this.rows[0].hasOwnProperty('table'); }
  isGroupedByInvoice() { return this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc'); }
  isGroupedByPOS() { return this.rows.length && this.rows[0].hasOwnProperty('pos'); }
  isGroupedByCategory() {return this.rows.length && this.rows[0].hasOwnProperty('pifamm_id'); }
  isGroupedByTag() { return this.rows && this.rows.length && this.rows[0].hasOwnProperty('tag_id'); }

  drillDownOnDate(rowDate) {
    this.dateFrom = this.moment(rowDate);
    this.dateTo = this.moment(rowDate);
    this.groupBy = '3';
    this.findSalesReport();
  }

  drillDownOnCashier(cashierId) {
    this.groupBy = '3';
    this.findSalesReport('15', cashierId);
  }

  drillDownOnPOS(posId) {
    this.groupBy = '3';
    this.findSalesReport('16', undefined, posId);
  }

  drillDownOnCategory(famId){
    this.groupBy = '3';
    this.findSalesReport('17', undefined, undefined, famId);
  }

  drillDownOnTable(tableId){
    this.groupBy = '3';
    let table = parseInt(tableId.split('-')[0].trim()) * 10;
    this.findSalesReport('18', undefined, undefined, undefined, table);
  }

  buildChartSalesReportByDate(dataset) {
    this.chartParams = {
      labels: dataset.map((row) => this.moment(row.date).format('DD-MM-YYYY')),
      data: [
        dataset.map((row) => row.total), dataset.map((row) => row.pax)
      ],
      series: ['Ventas', 'Personas'],
      datasetOverride: [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }],
      options: {
        scales: {
          yAxes: [
            { id: 'y-axis-1', type: 'linear', display: true, position: 'left' },
            { id: 'y-axis-2', type: 'linear', display: true, position: 'right' }
          ]
        }
      }
    };
  }


  buildChartSalesReportByCashier(dataset) {
    this.chartParams = {
      labels: dataset.map((row) => row.cashier),
      data: dataset.map((row) => row.total),
      options: {
        legend: {
          display: true,
          position: 'right'
        }
      }
    };
  }

  buildChartSalesReportByTable(dataset) {
    // TODO: build scatter chart here
  }

  buildChartSalesReportByPOS(dataset){
    this.chartParams = {
      labels: dataset.map((row) => { return row.pos }),
      data: dataset.map((row) => { return row.total }),
      options: {
        legend: {
          display: true,
          position: 'right'
        }
      }
    };
  }

  buildChartSalesReportByCategory(dataset) {
    this.chartParams = {
      labels: dataset.map((row) => row.pifamm_name),
      data: dataset.map((row) => row.total),
      options: {
        legend: {
          display: true,
          position: 'right'
        }
      }
    };
  }

  buildChartSalesReportByTag(dataset){
    this.chartParams = {
      labels: dataset.map(row => row.tag),
      data: dataset.map(row => row.total),
      options: {
        legend: {
          display: true,
          position: 'right'
        }
      }
    }
  }

  reorderCsv(){
    this.getCsvHeaders();
    this.getCsvHeaderOrder();
  }

  getCsvHeaders(){
    let usuals = ['Pax', 'Desc.',  'Prop.Extra', '% Ley', 'IVA', 'Total',];
    if (this.isGroupedByCashier()) {
      this.csvHeaders = ['Vendedor', 'Exención', ...usuals];
    } else if (this.isGroupedByDate()) {
      this.csvHeaders = ['Fecha', 'Exención', ...usuals]
    } else if (this.isGroupedByInvoice()) {
      this.csvHeaders = ['Fecha','Exención', 'NCF', 'RNC', 'Nombre', ...usuals];
    } else if (this.isGroupedByPOS()) {
      this.csvHeaders = ['POS', 'Exención',...usuals];
    } else if (this.isGroupedByTable()) {
      this.csvHeaders = ['Mesa', 'Exención', ...usuals];
    } else if (this.isGroupedByCategory()) {
      this.csvHeaders = ['Categoría', ...usuals];
    }
  }

  getCsvHeaderOrder(){
    let usuals = ["pax", "discount","extra_tip",  "tax10", "tax16", "total"];
    if (this.isGroupedByCashier()) {
      this.csvHeaderOrder = ['cashier',  'taxexemption', ...usuals];
    } else if (this.isGroupedByDate()) {
      this.csvHeaderOrder = ['date', 'taxexemption', ...usuals]
    } else if (this.isGroupedByInvoice()) {
      this.csvHeaderOrder = ['date', 'ncf', 'rnc', 'Nombre', 'taxexemption', ...usuals];
    } else if (this.isGroupedByPOS()) {
      this.csvHeaderOrder = ['pos', 'taxexemption', ...usuals];
    } else if (this.isGroupedByTable()) {
      this.csvHeaderOrder = ['table', 'taxexemption', ...usuals];
    } else if (this.isGroupedByCategory()) {
      this.csvHeaderOrder = ['pifamm_name', ...usuals];
    }
  }

}

 SalesReportController.$inject = ['ContentService', '$uibModal', 'moment', '$filter', 'isMobile', 'ProfilePermissionsService', '$state'];


// WEBPACK FOOTER //
// ./src/app/pages/sales-report/sales-report.controller.js